import { apiFetch } from "@/lib/api/client"

import type { CohortsResponse, CourseListResponse, CourseOut } from "./types"

export interface ListCoursesParams {
  q?: string
  is_active?: boolean
  direction?: string
  domain?: string
  limit?: number
  offset?: number
}

export function listCourses(
  params: ListCoursesParams = {},
  init?: RequestInit,
): Promise<CourseListResponse> {
  const qs = new URLSearchParams()
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null) continue
    if (typeof value === "boolean") {
      qs.set(key, value ? "true" : "false")
      continue
    }
    qs.set(key, String(value))
  }
  const query = qs.toString()
  return apiFetch<CourseListResponse>(
    `/api/courses/${query ? `?${query}` : ""}`,
    init,
  )
}

export function listCohorts(
  courseId: number,
  includeCohortId?: number | null,
  init?: RequestInit,
): Promise<CohortsResponse> {
  // `include_cohort_id` unions a specific (possibly past) cohort into the
  // upcoming list so a code-matched cohort the prefill pre-selected stays
  // pickable (cohorts-search-by-hubspot-code D8). Omitted when null/absent
  // — the endpoint then returns today's upcoming-only list.
  const query =
    includeCohortId != null ? `?include_cohort_id=${includeCohortId}` : ""
  return apiFetch<CohortsResponse>(
    `/api/courses/${courseId}/cohorts/${query}`,
    init,
  )
}

/**
 * Resolve a single Planna course by id. Backs the invoice edit form,
 * which needs the course a draft was issued against (its title and
 * native `currency`) even when that course is not in the currently
 * loaded catalogue page.
 */
export function getCourse(
  courseId: number,
  init?: RequestInit,
): Promise<CourseOut> {
  return apiFetch<CourseOut>(`/api/courses/${courseId}/`, init)
}
